export default __webpack_public_path__ + "static/media/social-02@2x.9e8972b1.webp";